<template>

  <b-overlay
    id="overlay-background"
    :show="loader === true"
    variant="dark"
    opacity="0.85"
    blur="2px"
    rounded="sm"
    spinner-variant="primary"
    spinner-medium
  >
    <b-card
      no-body
      class="card-payment"
    >
      <b-card-body>
        <b-tabs
          content-class="pt-1"
          fill
        >
          <b-tab
            active
            :title="$t('DEBTIA_GENERAL_SETTINGS')"
          >
            <general-settings :settings="settings" />
          </b-tab>
          <b-tab
            :title="$t('DEBTIA_CURRENCY_SETTINGS')"
          >
            <currency-settings :settings="settings" />
          </b-tab>
          <b-tab
            ref="bcAPISettingsTab"
            :title="$t('DEBTIA_BC_API_SETTINGS')"
          >
            <bcapi-settings :settings="settings" />
          </b-tab>
          <b-tab
            :title="$t('DEBTIA_EMAIL_SETTINGS')"
          >
            <email-settings :settings="apisettings" />
          </b-tab>
          <b-tab
            :title="$t('DEBTIA_STATEMENT_WIDGET')"
          >
            <statement-settings :settings="statementSettingValues" />
          </b-tab>
          <b-tab
            :title="$t('DEBTIA_EMAIL_TEMPLATE')"
          >
            <email-template :settings="apisettings" />
          </b-tab>
          <b-tab
            :title="$t('DEBTIA_NEW_CASE_REASON')"
          >
            <case-reasons :settings="apisettings" />
          </b-tab>
          <b-tab
            :title="$t('DEBTIA_INTEREST_SETTINGS')"
          >
            <interest-settings
              :statement-values="statementSettingValues"
              :settings="settings"
            />
          </b-tab>
          <b-tab
            :title="$t('DEBTIA_INSTALLMENT_PLAN')"
          >
            <installment-plan-settings :settings="settings" />
          </b-tab>
          <b-tab
            :title="$t('DEBTIA_DOCUMENT_WIDGET')"
          >
            <document-settings :settings="settings" />
          </b-tab>
        </b-tabs>
      </b-card-body>
    </b-card>
  </b-overlay>
</template>

<script>
import {
  BTabs, BTab, BCard, BCardBody, BOverlay,
} from 'bootstrap-vue'
import axios from '@axios'
import CurrencySettings from './CurrencySettings.vue'
import BcapiSettings from './BCAPISettings.vue'
import EmailSettings from './EmailSettings.vue'
import StatementSettings from './StatementSettings.vue'
import GeneralSettings from '../usersettings/UserSettings.vue'
import EmailTemplate from './EmailTemplate.vue'
import InterestSettings from './InterestSettings.vue'
import CaseReasons from './CaseReasons.vue'
import InstallmentPlanSettings from './InstallmentPlanSettings.vue'
import DocumentSettings from './DocumentSettings.vue'

export default {
  components: {
    BTabs,
    BTab,
    BCard,
    BCardBody,
    CurrencySettings,
    BcapiSettings,
    BOverlay,
    EmailSettings,
    StatementSettings,
    GeneralSettings,
    EmailTemplate,
    InterestSettings,
    CaseReasons,
    InstallmentPlanSettings,
    DocumentSettings,
  },
  data() {
    return {
      // codeFill,
      loader: false,
      settings: [],
      apisettings: {},
      statementSettingValues: [],
    }
  },
  created() {
    this.settingsData()
    this.getCommunicationApiSettings()
    this.getStatementSettings()
    if (localStorage.getItem('landToAdminSettings')) this.landToAdminSettings()
  },
  methods: {
    landToAdminSettings() {
      localStorage.removeItem('landToAdminSettings')
      setTimeout(() => {
        this.$refs.bcAPISettingsTab.activate()
      }, 2000)
    },
    async settingsData() {
      this.loader = true
      await axios.get('user-settings/get-all').then(response => {
        if (response.status) {
          this.settings = response.data.data
          this.loader = false
          // this.currencyselected = Number(response.data.data.value)
        }
      })
    },
    async getCommunicationApiSettings() {
      this.loader = true
      await axios.get('/api-token/default?module=communication').then(settings => {
        if (settings.status) {
          this.apisettings = settings.data.data
          // console.log('this.apisettings', this.apisettings)
          this.loader = false
        }
      })
    },
    async getStatementSettings() {
      this.loader = true
      axios.get('settings/get-statement-settings').then(response => {
        if (response.data.status) {
          this.statementSettingValues = response.data.data.statements
          this.statementSettingValues.forEach((item, index) => {
            if (item.status === true || item.status === 1) {
              this.statementSettingValues[index].status = true
            } else {
              this.statementSettingValues[index].status = false
            }
          })
        }
      })
    },
  },
}
</script>

<style lang="scss">
</style>
